<app-performance>
  <ng-container *ngIf="isLoading === true; else loaded">
    <ngx-skeleton-loader
        count="5"
        [theme]="{ 
            'height.px': 50
        }"
    ></ngx-skeleton-loader>
  </ng-container>
  <ng-template #loaded>
    <ng-container *ngIf="error === true; else noError">ERROR</ng-container>
    <ng-template #noError>
      <kendo-pdf-export #pdf paperSize="A4" margin="2cm">
        <div class="pdf-export-content" *ngIf="isExportingPdf">

          <div class="pdf-employee-header">
            <!-- <img 
              *ngIf="employeeImageUrl; else stockImage"
              class="pdf-employee-image" 
              [src]="employeeImageUrl"
            />
            <ng-template #stockImage>
              <img class="pdf-employee-image" src="assets/icons/stock-user.svg" />
            </ng-template> -->
            <div>
              <h2 class="pdf-employee-name">{{review?.employee?.firstName}} {{review?.employee?.lastName}}</h2>
              <span class="pdf-status-chip"
                [ngClass]="
                  review?.status?.id === 'Complete' ? 'green-chip' :
                  review?.status?.id === 'Archived' ? 'red-chip' :
                  review?.status?.id === 'InProgress' ? 'orange-chip' :
                  review?.status?.id === 'Pending' ? 'blue-chip' :
                  ''
                "
              >{{ review?.status?.name }}</span>
            </div>
            <div class="calculated-rating" *ngIf="review.reviewPlan?.displayCalculatedRating == true">
              {{ 'CalculatedRating' | translate: {Default: 'Calculated Rating'} }}: {{ review?.calculatedRating }}
            </div>
          </div>

          <mat-divider></mat-divider>

          <div class="pdf-section">
            <h3 class="pdf-section-title">{{ 'Review-Plan' | translate: {Default: 'Review Plan'} }}</h3>
            <div class="pdf-field">
              <span class="pdf-label">{{getLabel('tfi_RpName')}}</span>
              <span class="pdf-value">{{review?.reviewPlan?.name}}</span>
            </div>
            <div class="pdf-field" *ngIf="review?.reviewPlan?.description">
              <span class="pdf-label">{{getLabel('tfi_RpDescription')}}</span>
              <span class="pdf-value">{{review?.reviewPlan?.description}}</span>
            </div>
            <div class="pdf-field">
              <span class="pdf-label">{{getLabel('tfi_RpStartDate')}}</span>
              <span class="pdf-value">{{review?.reviewPlan?.startDate | date:'mediumDate'}}</span>
            </div>
            <div class="pdf-field">
              <span class="pdf-label">{{getLabel('tfi_RpEndDate')}}</span>
              <span class="pdf-value">{{review?.reviewPlan?.endDate | date:'mediumDate'}}</span>
            </div>
          </div>

          <mat-divider></mat-divider>

          <div class="pdf-section" *ngFor="let goalPlan of review?.goalPlans">
            <div class="pdf-goal-plan-header">
              <h3 class="pdf-section-title">{{goalPlan.name}}</h3>
              <span class="pdf-weight" *ngIf="goalPlan.weight">{{ 'Weight' | translate: {Default: 'Weight'} }}: {{goalPlan.weight}}%</span>
            </div>

            <div class="pdf-goal" *ngFor="let goal of goalPlan.goals">
              <h4 class="pdf-goal-title">{{goal.objective}}</h4>

              <div class="pdf-goal-details">
                <div class="pdf-field" *ngIf="goal.description">
                  <span class="pdf-label">{{ 'Description' | translate: {Default: 'Description'} }}</span>
                  <span class="pdf-value">{{goal.description}}</span>
                </div>
                <div class="pdf-field" *ngIf="goal.goalType">
                  <span class="pdf-label">{{ 'GoalType' | translate: {Default: 'Goal Type'} }}</span>
                  <span class="pdf-value">{{goal.goalType?.name}}</span>
                </div>
                <div class="pdf-field" *ngIf="goal.percentageComplete !== null">
                  <span class="pdf-label">{{ 'PercentageComplete' | translate: {Default: 'Percentage Complete'} }}</span>
                  <span class="pdf-value">{{goal.percentageComplete}}%</span>
                </div>
                <div class="pdf-field" *ngIf="goal.weight !== null">
                  <span class="pdf-label">{{ 'Weight' | translate: {Default: 'Weight'} }}</span>
                  <span class="pdf-value">{{goal.weight}}%</span>
                </div>
                <div class="pdf-field" *ngIf="goal.expectedCompletionDate">
                  <span class="pdf-label">{{ 'ExpectedCompletionDate' | translate: {Default: 'Expected Completion Date'} }}</span>
                  <span class="pdf-value">{{goal.expectedCompletionDate | date:'mediumDate'}}</span>
                </div>
                <div class="pdf-field" *ngIf="goal.actualCompletionDate">
                  <span class="pdf-label">{{ 'ActualCompletionDate' | translate: {Default: 'Actual Completion Date'} }}</span>
                  <span class="pdf-value">{{goal.actualCompletionDate | date:'mediumDate'}}</span>
                </div>
              </div>

              <div class="pdf-reviews" *ngIf="goal.reviews?.length > 0">
                <h5 class="pdf-reviews-title">{{ 'Reviews' | translate: {Default: 'Reviews'} }}</h5>
                <div class="pdf-review-item" *ngFor="let goalReview of goal.reviews">
                  <span class="pdf-reviewer-name">{{goalReview.reviewedBy?.firstName}} {{goalReview.reviewedBy?.lastName}}</span>
                  <div class="pdf-field" *ngIf="goalReview.rating">
                    <span class="pdf-label">{{ 'Rating' | translate: {Default: 'Rating'} }}</span>
                    <span class="pdf-value">{{goalReview.rating?.name}}</span>
                  </div>
                  <div class="pdf-field" *ngIf="goalReview.comments">
                    <span class="pdf-label">{{ 'Comments' | translate: {Default: 'Comments'} }}</span>
                    <span class="pdf-value">{{goalReview.comments}}</span>
                  </div>
                </div>
              </div>

              <div class="pdf-child-goals" *ngIf="goal.childGoals?.length > 0">
                <h5 class="pdf-child-goals-title">{{ 'Review-ChildGoals' | translate: {Default: 'Child Goals'} }}</h5>
                <div class="pdf-goal pdf-child-goal" *ngFor="let childGoal of goal.childGoals">
                  <h6 class="pdf-goal-title">{{childGoal.objective}}</h6>

                  <div class="pdf-goal-details">
                    <div class="pdf-field" *ngIf="childGoal.description">
                      <span class="pdf-label">{{ 'Description' | translate: {Default: 'Description'} }}</span>
                      <span class="pdf-value">{{childGoal.description}}</span>
                    </div>
                    <div class="pdf-field" *ngIf="childGoal.goalType">
                      <span class="pdf-label">{{ 'GoalType' | translate: {Default: 'Goal Type'} }}</span>
                      <span class="pdf-value">{{childGoal.goalType?.name}}</span>
                    </div>
                    <div class="pdf-field" *ngIf="childGoal.percentageComplete !== null">
                      <span class="pdf-label">{{ 'PercentageComplete' | translate: {Default: 'Percentage Complete'} }}</span>
                      <span class="pdf-value">{{childGoal.percentageComplete}}%</span>
                    </div>
                    <div class="pdf-field" *ngIf="childGoal.weight !== null">
                      <span class="pdf-label">{{ 'Weight' | translate: {Default: 'Weight'} }}</span>
                      <span class="pdf-value">{{childGoal.weight}}%</span>
                    </div>
                    <div class="pdf-field" *ngIf="childGoal.expectedCompletionDate">
                      <span class="pdf-label">{{ 'ExpectedCompletionDate' | translate: {Default: 'Expected Completion Date'} }}</span>
                      <span class="pdf-value">{{childGoal.expectedCompletionDate | date:'mediumDate'}}</span>
                    </div>
                    <div class="pdf-field" *ngIf="childGoal.actualCompletionDate">
                      <span class="pdf-label">{{ 'ActualCompletionDate' | translate: {Default: 'Actual Completion Date'} }}</span>
                      <span class="pdf-value">{{childGoal.actualCompletionDate | date:'mediumDate'}}</span>
                    </div>
                  </div>

                  <div class="pdf-reviews" *ngIf="childGoal.reviews?.length > 0">
                    <h6 class="pdf-reviews-title">{{ 'Reviews' | translate: {Default: 'Reviews'} }}</h6>
                    <div class="pdf-review-item" *ngFor="let childReview of childGoal.reviews">
                      <span class="pdf-reviewer-name">{{childReview.reviewedBy?.firstName}} {{childReview.reviewedBy?.lastName}}</span>
                      <div class="pdf-field" *ngIf="childReview.rating">
                        <span class="pdf-label">{{ 'Rating' | translate: {Default: 'Rating'} }}</span>
                        <span class="pdf-value">{{childReview.rating?.name}}</span>
                      </div>
                      <div class="pdf-field" *ngIf="childReview.comments">
                        <span class="pdf-label">{{ 'Comments' | translate: {Default: 'Comments'} }}</span>
                        <span class="pdf-value">{{childReview.comments}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="pdf-goal-plan-reviews" *ngIf="goalPlan.reviews?.length > 0">
              <h4 class="pdf-reviews-title">{{ 'Review-RatingsAndComments' | translate: {Default: 'Ratings & Comments'} }}</h4>
              <div class="pdf-review-item" *ngFor="let planReview of goalPlan.reviews">
                <span class="pdf-reviewer-name">{{planReview.reviewedBy?.firstName}} {{planReview.reviewedBy?.lastName}}</span>
                <div class="pdf-field" *ngIf="planReview.rating">
                  <span class="pdf-label">{{ 'Rating' | translate: {Default: 'Rating'} }}</span>
                  <span class="pdf-value">{{planReview.rating?.name}}</span>
                </div>
                <div class="pdf-field" *ngIf="planReview.comments">
                  <span class="pdf-label">{{ 'Comments' | translate: {Default: 'Comments'} }}</span>
                  <span class="pdf-value">{{planReview.comments}}</span>
                </div>
              </div>
            </div>

            <mat-divider></mat-divider>
          </div>

          <div class="pdf-section" *ngIf="review?.reviews !== null && review?.reviews?.length > 0">
            <h3 class="pdf-section-title">{{ 'Review-RatingsAndComments' | translate: {Default: 'Ratings & Comments'} }}</h3>
            <div class="pdf-review-item" *ngFor="let overallReview of review.reviews">
              <span class="pdf-reviewer-name">{{overallReview.reviewedBy?.firstName}} {{overallReview.reviewedBy?.lastName}}</span>
              <div class="pdf-field" *ngIf="overallReview.rating">
                <span class="pdf-label">{{ 'Rating' | translate: {Default: 'Rating'} }}</span>
                <span class="pdf-value">{{overallReview.rating?.name}}</span>
              </div>
              <div class="pdf-field" *ngIf="overallReview.comments">
                <span class="pdf-label">{{ 'Comments' | translate: {Default: 'Comments'} }}</span>
                <span class="pdf-value">{{overallReview.comments}}</span>
              </div>
            </div>
          </div>

        </div>
      </kendo-pdf-export>

        <mat-card class="mat-elevation-z0">
            <mat-card-title class="header">
              <h5 mat-dialog-title>{{ 'Review' | translate: {Default: 'Review'} }} - {{review.reviewPlan?.name}}</h5>
              <mat-chip 
                [ngClass]="
                  review?.status?.id === 'Complete' ? 'green-chip' : 
                  review?.status?.id === 'Archived' ? 'red-chip' :
                  review?.status?.id === 'InProgress' ? 'orange-chip' :
                  review?.status?.id === 'Pending' ? 'blue-chip' :
                  ''
                "
              >{{ review?.status?.name }}</mat-chip>

              <div class="calculated-rating" *ngIf="review.reviewPlan?.displayCalculatedRating == true">
                {{ 'CalculatedRating' | translate: {Default: 'Calculated Rating'} }}: {{ review?.calculatedRating }}
              </div>
          
              <div class="k-flex-grow"></div>
        
              
              <button class="mat-stroked-button" appPreventDoubleClick (throttledClick)="navigateBack()">{{ 'Close' | translate: {Default: "Close"} }}</button>
              
              <ng-container *ngIf="review?.status?.id === 'Complete'">
                <button 
                  *appHasFeature="features.PERFORMANCE_REVIEW_PLANS_ADMINISTRATION"
                  class="export-to-pdf-button" 
                  appLocalizationPopupDirective 
                  localizationCode="ExportPdf" 
                  mat-stroked-button 
                  appPreventDoubleClick 
                  (throttledClick)="exportToPdf()"
                >
                    <img
                        class="ms-icon"
                        src="assets/icons/pdf-icon.svg"
                        style="width: 25px;
                                    height: 35px;
                                    vertical-align: middle;">
                    {{ 'ExportPdf' | translate: {Default: "Export PDF"} }}
                </button>
              </ng-container>
              
              <div *ngIf="review?.status?.id === 'InProgress'">
                <button 
                    *ngIf="review.currentUser.isReviewPlanOwner"
                    appLocalizationPopupDirective 
                    localizationCode="RevertReview" 
                    mat-stroked-button 
                    setColor="primaryColour"
                    color="primary" 
                    appPreventDoubleClick 
                    (throttledClick)="revertReview()"
                >{{ 'RevertReview' | translate: {Default: "Revert Review"} }}</button>  

                <button 
                    *ngIf="review.currentUser.isPendingForReview"
                    appLocalizationPopupDirective 
                    localizationCode="CompleteReview" 
                    mat-flat-button 
                    setColor="primaryColour"
                    color="primary" 
                    appPreventDoubleClick 
                    (throttledClick)="openConfirmationWarning()"
                >{{ 'CompleteReview' | translate: {Default: "Complete Review"} }}</button>  
              </div>
            </mat-card-title>
        
            <mat-card-content class="">
              <ng-container *ngIf="isLoading; else loaded">
                <ngx-skeleton-loader
                  count="5"
                  [theme]="{ 
                      'height.px': 50
                  }"
                ></ngx-skeleton-loader>
              </ng-container>
        
              <ng-template #loaded>
                <div class="top-row">
                  <app-employee-contact-card [employeeId]="review?.employee?.id"></app-employee-contact-card>
        
                  <mat-card class="review-plan">
                      <mat-card-title>
                          <h6 appLocalizationPopupDirective localizationCode="Review-Plan" >{{ 'Review-Plan' | translate: {Default: 'Review Plan'} }}</h6>
                      </mat-card-title>
        
                      <mat-card-content>
                        <div>
                          <div class="label">{{getLabel('tfi_RpName')}}</div>
                          <div class="value">{{review.reviewPlan?.name}}</div>
                        </div>
                        <div>
                          <div class="label">{{getLabel('tfi_RpDescription')}}</div>
                          <div class="value">{{review.reviewPlan?.description}}</div>
                        </div>
                        <div>
                          <div class="label">{{getLabel('tfi_RpStartDate')}}</div>
                          <div class="value">{{review.reviewPlan?.startDate | date:'mediumDate'}}</div>
                        </div>
                        <div>
                          <div class="label">{{getLabel('tfi_RpEndDate')}}</div>
                          <div class="value">{{review.reviewPlan?.endDate | date:'mediumDate'}}</div>
                        </div>
                      </mat-card-content>
                  </mat-card>
                </div>
    
                <div class="bottom-row">
                  <mat-tab-group class="mat-tab-group">
    
                    <mat-tab>
                      <ng-template mat-tab-label>
                        <div class="mat-tab-header" appLocalizationPopupDirective localizationCode="Review-Reviews">
                          {{ 'Review-Reviews' | translate: {Default: 'Reviews'} }}

                          <mat-icon *ngIf="review.allGoalPlansReviewStatus === 'reviewed'" class="complete material-icons-outlined" [matTooltip]="translate.instant('Reviewed')">check_circle</mat-icon>
                          <mat-icon *ngIf="review.allGoalPlansReviewStatus === 'needsReview'" class="need-input material-icons-outlined" [matTooltip]="translate.instant('NeedsInput')">feedback</mat-icon>

                        </div>
                      </ng-template>

                      <app-review-goals-section 
                        [review]="review" 
                        (saveGoalPlanReview)="saveGoalPlanReview($event)" 
                        (saveGoalReview)="saveGoalReview($event)"
                      ></app-review-goals-section>
                    </mat-tab>
    
                    <mat-tab *ngIf="review?.reviews !== null && review?.reviews.length > 0">
                      <ng-template mat-tab-label>
                        <div class="mat-tab-header" appLocalizationPopupDirective localizationCode="Review-RatingsAndComments">
                          {{ 'Review-RatingsAndComments' | translate: {Default: 'Ratings & Comments'} }}

                          <mat-icon *ngIf="review.overallReviewStatus === 'reviewed'" class="complete material-icons-outlined" [matTooltip]="translate.instant('Reviewed')">check_circle</mat-icon>
                          <mat-icon *ngIf="review.overallReviewStatus === 'needsReview'" class="need-input material-icons-outlined" [matTooltip]="translate.instant('NeedsInput')">feedback</mat-icon>

                        </div>
                      </ng-template>
                      
                      <mat-card class="ratings-and-comments">
                        <mat-card-title>
                            <h6>{{ 'Review-RatingsAndComments' | translate: {Default: 'Ratings & Comments'} }}</h6>
                        </mat-card-title>
            
                        <mat-card-content>
                          <div class="reviews">
                            <div *ngFor="let r of review.reviews; let last = last">
                              <app-overall-rating-comment
                                class="review"
                                [reviewPlanId]="review.reviewPlan.id"
                                [review]="r"
                                [reviewerPermissions]="getReviewerPermissions(r.reviewedBy.id)"
                                (saveReview)="saveReview($event)"
                              ></app-overall-rating-comment>
                              <mat-divider *ngIf="!last"></mat-divider>
                            </div>
                          </div>
                        </mat-card-content>
                      </mat-card>
                    </mat-tab>
    
                    <mat-tab>
                      <ng-template mat-tab-label>
                        <div appLocalizationPopupDirective localizationCode="Review-Reviewers">
                          {{ 'Review-Reviewers' | translate: {Default: 'Reviewers'} }}
                        </div>
                      </ng-template>

                      <app-local-data-grid-comp
                          [tableId]="db_tables.PerformanceReviewPlanReviewers"
                          [category]="translate.instant('Review-Reviewers')"
                          class="reviewers-data-grid"
                          [columns]="reviewerColumns"
                          [data]="review?.reviewers"
                          [isLoading]="isLoading"
                          [pageable]="false"
                      ></app-local-data-grid-comp>
                    </mat-tab>
                  </mat-tab-group>
                </div>
              </ng-template>
            </mat-card-content>
        </mat-card>
    </ng-template>
  </ng-template>

</app-performance>
